import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Container, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";

const BreadcrumbBar = ({ items, current }, context) => {
  // Fetch the language from the Redux store
  const language = useSelector((state) => state.i18nState.lang);

  return (
    <Container>
      {/* Mobile Breadcrumb */}
      <Breadcrumb listClassName="bg-white mb-0 d-block d-lg-none">
        {items.length > 0 && (
          <BreadcrumbItem key="breadcrumb-md">
            <Link to={items[items.length - 1]?.link}>
              &laquo; {items[items.length - 1]?.title}
            </Link>
          </BreadcrumbItem>
        )}
      </Breadcrumb>

      {/* Desktop Breadcrumb */}
      <Breadcrumb listClassName="bg-white mb-0 d-none d-lg-flex">
        <BreadcrumbItem>
          <Link to={`/${language}/shop/`}>{context.t("myfolie shop")}</Link>
        </BreadcrumbItem>
        {items.map((breadcrumb, idx) => (
          <BreadcrumbItem key={`breadcrumb-${idx}`}>
            <Link to={breadcrumb.link}>{breadcrumb.title}</Link>
          </BreadcrumbItem>
        ))}
        {current && <BreadcrumbItem active>{current.title}</BreadcrumbItem>}
      </Breadcrumb>
    </Container>
  );
};

// PropTypes Validation
BreadcrumbBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  current: PropTypes.shape({
    title: PropTypes.string,
  }),
};

// Context Types
BreadcrumbBar.contextTypes = {
  t: PropTypes.func,
};

export default BreadcrumbBar;
